// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"Pagination_paginationWrapper__kGR4N"};